import axios from "axios"

export interface Country {
  name: string
  flag_url: string
  flag_flat: string
  description: string
  link: string
  iso_code: string
}

interface CountryApiResponse {
  title: string
  body: string
  field_iso_2: string
  langcode: string
  field_flag: string
  field_flag_wavy: string
  view_node: string
}

export default class CountryDataManager {
  private static instance: CountryDataManager | null = null;
  private static instancePromise: Promise<CountryDataManager>

  static async getInstance() {
    if (!CountryDataManager.instance) {
      
      if(!CountryDataManager.instancePromise) {
        CountryDataManager.instancePromise = new Promise<CountryDataManager>( (resolve, reject) => {
          const instance = new CountryDataManager()
          instance.fetchData().then( _ => {
            CountryDataManager.instance = instance
            resolve(instance)
          }).catch( (error: Error) => reject(error) )
        })
        return await CountryDataManager.instancePromise
      } else {
        return await CountryDataManager.instancePromise
      }
    }
    return CountryDataManager.instance;
  }

  private api_endpoint = "/api/member-states"
  private country_data: CountryApiResponse[] = []

  private async fetchData() {
    this.country_data = await axios.get(`${process.env.REACT_APP_BASE_API}${this.api_endpoint}`)
      .then(response => {
        return response.data
      })
      .catch(error => {
        throw new Error(`Network request failed: ${error.message}`);
      })
  }

  public getCountry(iso_code: string, langcode = "EN") {
    let country = this.country_data.find( (country: CountryApiResponse) => country.field_iso_2 === iso_code && country.langcode.toUpperCase() === langcode.toUpperCase())
    if(country === null && langcode !== "EN") {
      // Try to get default in langcode = en
      country = this.country_data.find( (country: CountryApiResponse) => country.field_iso_2 === iso_code && country.langcode.toUpperCase() === "EN")
    }
    if(country != null) {
      let responseCountry: Country = {
        name: country.title,
        flag_url: `${process.env.REACT_APP_BASE_API}${country.field_flag_wavy}`,
        flag_flat: `${process.env.REACT_APP_BASE_API}${country.field_flag}`,
        description: country.body,
        link: country.view_node,
        iso_code: country.field_iso_2
      }
      return responseCountry
    } else {
      throw new Error("Country not found.")
    }
  }

  public getCountriesList() {
    let country_iso_code: any = {}
    this.country_data.map( (country: CountryApiResponse) => country_iso_code[country.field_iso_2] = true )
    return Object.keys(country_iso_code).sort((a: any, b: any) => a - b)
  }
}